import { render, staticRenderFns } from "./hourinterrecord.vue?vue&type=template&id=2fad010d&"
import script from "./hourinterrecord.vue?vue&type=script&lang=ts&"
export * from "./hourinterrecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "hourinterrecord.vue"
export default component.exports